import { GithubLogo, GooglePlayLogo, AppleLogo, Info, X } from "@phosphor-icons/react";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "../components/card";
import { useLanguage } from "../context/language";
import { Button } from "../components/button";
import { useState } from "react";
import { getProjects } from "../utils/projects";

export function Projects() {
  const { language } = useLanguage();
  const projects = getProjects(language);
  const [selectedProject, setSelectedProject] = useState<number | null>(null);

  return (
    <>
      <h1 className="text-center text-white text-5xl pt-10 pb-10 mobile:text-4xl">
        {language === "pt" ? "Projetos" : "Projects"}
      </h1>
      <div className="p-10 flex gap-5 flex-wrap justify-center items-center">
        {projects.map((project) => (
          <Card key={project.id} className="w-72 h-[22rem] transition-transform duration-300 hover:scale-105">
            <CardHeader>
              <div className="flex items-center justify-center relative">
                <CardTitle className="text-center">{project.title}</CardTitle>
                {project.infoLink && (
                  <a href={project.infoLink} className="absolute right-0 top-0 text-vermelhoPrincipal hover:text-vermelhoPrincipal/80 transition-colors">
                    <Info size={22} />
                  </a>
                )}
              </div>
            </CardHeader>
            <CardContent className="flex flex-col items-center justify-center gap-3">
              <img
                className="w-40 h-40 rounded-3xl"
                src={project.image}
                alt={`icon ${project.title}`}
              />
              <div className="flex items-center gap-3 justify-center">
                {project.link.includes("github.com") && (
                  <a href={project.link} target="_blank" rel="noreferrer" className="text-vermelhoPrincipal hover:text-vermelhoPrincipal/80 transition-colors">
                    <GithubLogo size={32} />
                  </a>
                )}

                {project.link.includes("play.google.com") && (
                  <a href={project.link} target="_blank" rel="noreferrer" className="text-vermelhoPrincipal hover:text-vermelhoPrincipal/80 transition-colors">
                    <GooglePlayLogo size={32} />
                  </a>
                )}
                <p className="text-sm text-white">{project.description}</p>
              </div>
            </CardContent>
            <CardFooter className="flex justify-center gap-2">
              {project.link.includes("play.google.com") && (
                <>
                  <Button className="p-0 bg-transparent hover:bg-transparent border-0 -mt-5">
                    <a
                      rel="noreferrer"
                      href={project.link}
                      target="_blank"
                      className="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-buttonBackground hover:bg-buttonBackgroundHover border border-borderGray hover:border-vermelhoPrincipal text-white text-sm font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                    >
                      <GooglePlayLogo size={16} />
                      {language === "pt" ? "Play Store" : "Play Store"}
                    </a>
                  </Button>
                  {project.appleLink && (
                    <Button className="p-0 bg-transparent hover:bg-transparent border-0 -mt-5">
                      <a
                        rel="noreferrer"
                        href={project.appleLink}
                        target="_blank"
                        className="flex items-center justify-center gap-1.5 px-3 py-1.5 bg-buttonBackground hover:bg-buttonBackgroundHover border border-borderGray hover:border-vermelhoPrincipal text-white text-sm font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                      >
                        <AppleLogo size={16} />
                        {language === "pt" ? "App Store" : "App Store"}
                      </a>
                    </Button>
                  )}
                </>
              )}

              {project.link.includes("github.com") && (
                <Button className="p-0 bg-transparent hover:bg-transparent border-0 -mt-5">
                  <a
                    rel="noreferrer"
                    href={project.link}
                    target="_blank"
                    className="flex items-center justify-center gap-2 px-6 py-2.5 bg-buttonBackground hover:bg-buttonBackgroundHover border border-borderGray hover:border-vermelhoPrincipal text-white font-medium rounded-lg transition-all duration-300 hover:shadow-lg hover:scale-105"
                  >
                    <GithubLogo size={18} />
                    {language === "pt" ? "GitHub" : "GitHub"}
                  </a>
                </Button>
              )}
              {/* <Button className="p-0 -mt-5" onClick={() => setSelectedProject(project.id)}>
                {language === "pt" ? "Ver mais" : "See more"}
              </Button> */}
            </CardFooter>
          </Card>
        ))}
      </div>

      {selectedProject && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white p-5 rounded-lg w-96">
            <div className="flex justify-between">
              <h2 className="text-xl font-bold">{projects.find(p => p.id === selectedProject)?.title}</h2>
              <button onClick={() => setSelectedProject(null)}><X size={24} /></button>
            </div>
            <p className="mt-2">{projects.find(p => p.id === selectedProject)?.details}</p>
            <p className="mt-2"><strong>{language === "pt" ? "Tecnologias:" : "Technologies:"}</strong> {projects.find(p => p.id === selectedProject)?.technologies.join(", ")}</p>
          </div>
        </div>
      )}
    </>
  );
}